import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconChevronLeft = forwardRef<SVGSVGElement, IconProps>(
  function IconChevronLeft(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-6 h-6 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M15.6368 2.69995L7.6868 11.6999C7.61451 11.7832 7.57471 11.8897 7.57471 11.9999C7.57471 12.1102 7.61451 12.2167 7.6868 12.2999L15.6368 21.2999C15.6761 21.3444 15.7238 21.3807 15.7771 21.4067C15.8305 21.4327 15.8885 21.4479 15.9477 21.4514C16.007 21.4549 16.0664 21.4466 16.1224 21.427C16.1784 21.4075 16.2301 21.377 16.2743 21.3374C16.3624 21.257 16.4157 21.1454 16.4227 21.0263C16.4297 20.9072 16.3899 20.7901 16.3118 20.6999L8.6243 11.9999L16.3118 3.29995C16.3899 3.20977 16.4297 3.09266 16.4227 2.97357C16.4157 2.85448 16.3624 2.74284 16.2743 2.66245C16.2301 2.62286 16.1785 2.59241 16.1224 2.57286C16.0664 2.5533 16.007 2.54503 15.9477 2.54852C15.8885 2.552 15.8305 2.56718 15.7771 2.59317C15.7238 2.61916 15.6761 2.65545 15.6368 2.69995Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
